import React, { useState } from "react";
import { Box, Typography, TextField, Button, Rating } from "@mui/material";
import globalStyles from "../../global"; // Adjust the path as per your folder structure


const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

const FeedbackComponent = () => {
  const [rating, setRating] = useState(0);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    feedback: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Submit logic here
  };

  return (
    <Box
      sx={{
        width: "100%",
        background: "#fff",
        minHeight: { xs: "auto", md: "440px" },
        borderRadius: "0",
        px: { xs: 1, md: 4 },
        py: { xs: 2, md: 4 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "centre",
        justifyContent:"space-evenly",
        gap: { xs: 4, md: 8 },
        boxSizing: "border-box",
      }}
    >
      {/* Form Section */}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          flex: 1,
          maxWidth: "550px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: globalStyles.colors.army_green,
            letterSpacing: 0.5,
            fontFamily: globalStyles.fonts.primaryGlobal,
            mb: 1,
          }}
        >
          LEAVE A FEEDBACK
        </Typography>
        <Box sx={{ display: "flex", gap: 2, mb: 1 }}>
          <TextField
            label="Full Name"
            name="fullName"
            placeholder="ex. John Doe"
            value={formData.fullName}
            onChange={handleInputChange}
            required
            variant="outlined"
            fullWidth
            InputLabelProps={{
              style: { fontFamily: globalStyles.fonts.primary, fontSize: "15px" },
            }}
            inputProps={{
              style: { fontFamily: globalStyles.fonts.primary, fontSize: "15px" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            }}
          />
          <TextField
            label="Email Address (optional)"
            name="email"
            placeholder="ex. johndoe@eg"
            value={formData.email}
            onChange={handleInputChange}
            variant="outlined"
            fullWidth
            InputLabelProps={{
              style: { fontFamily: globalStyles.fonts.primary, fontSize: "15px" },
            }}
            inputProps={{
              style: { fontFamily: globalStyles.fonts.primary, fontSize: "15px" },
            }}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            }}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography
            sx={{
              fontFamily: globalStyles.fonts.primary,
              fontWeight: 600,
              color: globalStyles.colors.text,
              fontSize: globalStyles.textSizes.medium,
              mr: 2,
            }}
          >
            Rating:
          </Typography>
          <Rating
            name="rating"
            value={rating}
            onChange={(event, newValue) => setRating(newValue)}
            sx={{
              "& .MuiRating-iconFilled": { color: "#F4A261" },
              "& .MuiRating-iconEmpty": { color: "#E0E0E0" },
              fontSize: 32,
            }}
          />
        </Box>
        <TextField
          label="Feedback (optional)"
          name="feedback"
          placeholder="Tell us more about your interest in opening an UClean franchise with us"
          value={formData.feedback}
          onChange={handleInputChange}
          variant="outlined"
          fullWidth
          multiline
          minRows={4}
          InputLabelProps={{
            style: { fontFamily: globalStyles.fonts.primary, fontSize: "15px" },
          }}
          inputProps={{
            style: { fontFamily: globalStyles.fonts.primary, fontSize: "15px" },
          }}
          sx={{
            "& .MuiOutlinedInput-root": { borderRadius: "8px" },
          }}
        />
        <Button
          type="submit"
          variant="contained"
          sx={{
            width: "fit-content",
            px: 4,
            py: 1.2,
            mt: 1,
            borderRadius: "8px",
            background: globalStyles.colors.uclean_green,
            color: "#fff",
            fontWeight: 600,
            fontFamily: globalStyles.fonts.primary,
            textTransform: "none",
            fontSize: "16px",
            '&:hover': {
              background: globalStyles.colors.army_green,
            },
          }}
        >
          Submit Feedback
        </Button>
      </Box>

      {/* Image Section */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          minWidth: { xs: "100%", md: "350px" },
          maxWidth: { xs: "100%", md: "380px" },
        }}
      >
        <Box
          component="img"
           src={`${imageBaseUrl}feedback.svg`}
          alt="Leave Feedback"
          sx={{
            width: { xs: "100%", md: "350px" },
            height: { xs: "auto", md: "320px" },
            borderRadius: "20px",
            objectFit: "cover",
            boxShadow: "0 2px 24px 0 rgba(0,0,0,0.10)",
          }}
        />
        {/* Star Ribbon */}
        <Box
          sx={{
            position: "absolute",
            top: "68%",
            left: "14%",
            background: "#fff",
            borderRadius: "16px",
            px: 2,
            py: 0.5,
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.10)",
            display: "flex",
            alignItems: "center",
            transform: "rotate(-16deg)",
            minWidth: "80px",
          }}
        >
          <Typography
            sx={{
              color: "#F4A261",
              fontSize: "22px",
              fontFamily: globalStyles.fonts.primary,
              fontWeight: 700,
              letterSpacing: 1,
              userSelect: "none",
            }}
          >
            ★★★★★
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FeedbackComponent;